import styled from "styled-components";

export const FooterActionsStyles = styled.div`
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  display: flex;
  gap: ${({ theme }) => theme.spacing[12]};
  padding: ${({ theme }) => theme.spacing[16]}
    ${({ theme }) => theme.spacing[20]};
  background: ${({ theme }) => theme.colors.semantic.container.white};
  box-shadow: 0 -6px 24px rgba(16, 24, 40, 0.08);

  button {
    flex: 1 1 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing[8]};
    padding: ${({ theme }) => theme.spacing[12]}
      ${({ theme }) => theme.spacing[12]};
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
  }

  .notification-counter {
    width: 18px;
    height: 18px;
  }
`;
